import { axiosApiInstance, headers } from './_httpHeaders';

// 1. 문서조회 문서 타입 코드 조회
export const getDocuCodeList = (sysGroupCode) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/jjjjjj.do`,
    params: {
      sysGroupCode: sysGroupCode,
    },
  });

// 1. 유통사 리스트 조회
export const getDistributorList = (documentinfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectDistributorList.do`,
    params: {
      docType: documentinfo.documentType,
    },
  });

// 1. 유통사 리스트 조회(3PL)
export const getDistributor3PlList = (documentinfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectDistributor3PlList.do`,
    params: {
      docType: documentinfo.documentType,
    },
  });

  // 1. 제조사 리스트 조회(3PL)
export const getManufacturer3PlList = (documentinfo) =>
axiosApiInstance({
  method: 'get',
  headers: headers,
  url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectManufacturer3PlList.do`,
  params: {
    usCode: documentinfo.usCode,
  },
});

export const getUserCodeList = (documentinfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectUserCodeList.do`,
    params: {
      coBrno: documentinfo.coBrno,
      coNm: documentinfo.coNm,
      usCode: documentinfo.usCode,
      coRprsNm: documentinfo.coRprsNm,
      searchText: documentinfo.searchText,
    },
  });

// 1. 문서리스트 조회
export const getDocumentList = (documentinfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectDocumentList.do`,
    params: {
      docType: documentinfo.documentType, //문서상태
      search: documentinfo.searchText, //검색어
      startDt: documentinfo.startDt,
      endDt: documentinfo.endDt,
      startDate: documentinfo.startDt, //시작기간
      endDate: documentinfo.endDt, // 종료기간
      dateType: documentinfo.termsSearchType, // 조회일구분
      distributor: documentinfo.distributor, // 유통사 구분
      manufacturer: documentinfo.manufacturer, // 유통사 구분 - 제조사
      manufacturerValue: documentinfo.manufacturerValue, // 유통사 구분 - 제조사
      centerCd: documentinfo.centerCd, // 제조사 구분
      centerCdValue: documentinfo.centerCdValue,
      businessCd: documentinfo.businessCd, // 업태코드
      tmpReceiveTypeList: documentinfo.tmpReceiveTypeList,
      doc: documentinfo.doc, // 조회문서
      termsType: documentinfo.termsType,
      usCode: documentinfo.usCode, // 고객코드
      gubun: documentinfo.gubun,
      pageStart: documentinfo.pageStart,
      readCount: documentinfo.perPageNum,
    },
  });

//2. 문서상세조회
export const getDocumentDetail = (documentinfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/selectDocumentDetail.do`,
    params: {
      mesgNo: documentinfo.mesg_no,
      usCode: documentinfo.usCode,
      doc: documentinfo.doc,
    },
  });
//2. 문서CSV다운로드
export const getDocuListFileDown = (documentinfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'arraybuffer',
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/getDocuListFileDown.do`,
    params: {
      // listData: documentinfo.listData,
      docType: documentinfo.documentType, //문서상태
      search: documentinfo.searchText, //검색어
      startDate: documentinfo.startDt, //시작기간
      endDate: documentinfo.endDt, // 종료기간
      dateType: documentinfo.termsSearchType, // 조회일구분
      distributor: documentinfo.distributor,
      doc: documentinfo.doc, // 조회문서
      businessCd: documentinfo.businessCd, // 업태코드
      usCode: documentinfo.usCode, // 고객코드
      pageStart: documentinfo.pageStart,
      readCount: documentinfo.perPageNum,
      // list: documentinfo,
    },
  });
//2. 문서EXCEL다운로드
export const getDocuListExcelDown = (documentinfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'arraybuffer',
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/getDocuListExcelDown.do`,
    params: {
      // listData: documentinfo.listData,
      docType: documentinfo.documentType, //문서상태
      search: documentinfo.searchText, //검색어
      startDate: documentinfo.startDt, //시작기간
      endDate: documentinfo.endDt, // 종료기간
      dateType: documentinfo.termsSearchType, // 조회일구분
      distributor: documentinfo.distributor,
      doc: documentinfo.doc, // 조회문서
      manufacturer: documentinfo.manufacturer,
      centerCd: documentinfo.centerCd,
      businessCd: documentinfo.businessCd, // 업태코드
      usCode: documentinfo.usCode, // 고객코드
      gubun : documentinfo.gubun,
      pageStart: documentinfo.pageStart,
      readCount: documentinfo.perPageNum,
      // list: documentinfo,
    },
  });

//2. 문서EXCEL다운로드
export const getDocuListExcelAllDown = (documentinfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'arraybuffer',
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/getDocuListExcelAllDown.do`,
    params: {
      // listData: documentinfo.listData,
      docType: documentinfo.documentType, //문서상태
      search: documentinfo.searchText, //검색어
      startDate: documentinfo.startDt, //시작기간
      endDate: documentinfo.endDt, // 종료기간
      dateType: documentinfo.termsSearchType, // 조회일구분
      distributor: documentinfo.distributor,
      doc: documentinfo.doc, // 조회문서
      businessCd: documentinfo.businessCd, // 업태코드
      usCode: documentinfo.usCode, // 고객코드
      pageStart: documentinfo.pageStart,
      readCount: documentinfo.perPageNum,
      // list: documentinfo,
    },
  });  

//2. 문서CSV다운로드
export const getDocuDetailFileDown = (documentinfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'arraybuffer',
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/getDocuDetailFileDown.do`,
    params: {
      mesgNo: documentinfo.mesg_no,
      usCode: documentinfo.usCode,
      doc: documentinfo.doc,
      pageStart: documentinfo.pageStart,
      readCount: documentinfo.perPageNum,
    },
  });
//2. 문서EXCEL다운로드
export const getDocuDetailExcelDown = (documentinfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'arraybuffer',
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/getDocuDetailExcelDown.do`,
    params: {
      mesgNo: documentinfo.mesg_no,
      usCode: documentinfo.usCode,
      doc: documentinfo.doc,
      gubun: documentinfo.gubun,
      pageStart: documentinfo.pageStart,
      readCount: documentinfo.perPageNum,
    },
  });
//2. 문서EXCEL다운로드
export const getDocuDetailAllExcelDown = (documentinfo) =>
  axiosApiInstance({
    method: 'get',
    headers: headers,
    responseType: 'arraybuffer',
    url: `${process.env.REACT_APP_API_URL}/user/servicecntr/getDocuDetailAllExcelDown.do`,
    params: {
      mesgNo: documentinfo.mesg_no,
      usCode: documentinfo.usCode,
      doc: documentinfo.doc,
      gubun: documentinfo.gubun,
      pageStart: documentinfo.pageStart,
      readCount: documentinfo.perPageNum,
    },
  });
  //2. 문서EXCEL다운로드
export const getDocuAllExcelDown = (documentinfo) =>
  axiosApiInstance({
      method: 'get',
      headers: headers,
      responseType: 'arraybuffer',
      url: `${process.env.REACT_APP_API_URL}/user/servicecntr/getDocuAllExcelDown.do`,
      params: {
        // listData: documentinfo.listData,
        docType: documentinfo.documentType, //문서상태
        search: documentinfo.searchText, //검색어
        startDate: documentinfo.startDt, //시작기간
        endDate: documentinfo.endDt, // 종료기간
        dateType: documentinfo.termsSearchType, // 조회일구분
        distributor: documentinfo.distributor,
        doc: documentinfo.doc, // 조회문서
        usCode: documentinfo.usCode, // 고객코드
        manufacturer: documentinfo.manufacturer,
        centerCd: documentinfo.centerCd,
        businessCd: documentinfo.businessCd, // 업태코드
        gubun : documentinfo.gubun,
        pageStart: documentinfo.pageStart,
        readCount: documentinfo.perPageNum,
        // list: documentinfo,
      },
    });
